const API_BASE = '/api/ai';

export interface IntroGeneratorInput {
  name: string;
  profession: string;
  strengths: string[];
  hobbies: string[];
}

export interface ProjectDescInput {
  projectName: string;
  techStack: string[];
  overview: string;
}

export interface SkillSuggestInput {
  currentSkills: string[];
  interests: string[];
}

export interface SkillSuggestion {
  skill: string;
  reason: string;
}

export interface SkillAnalyzeInput {
  yearsOfExperience: number;
  jobTitle: string;
  technologies: string[];
  specialties?: string[];
  projectSummary?: string;
  certifications?: string[];
}

export interface AnalyzedSkill {
  name: string;
  level: number;
  category: 'Frontend' | 'Backend' | 'Language' | 'Infrastructure' | 'Other';
}

export interface NextSkillsInput {
  currentSkills: { name: string; level: number }[];
}

export async function generateIntroduction(input: IntroGeneratorInput): Promise<string> {
  const response = await fetch(`${API_BASE}/generate-intro`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'AI生成に失敗しました');
  }

  const data = await response.json();
  return data.introduction;
}

export async function generateProjectDescription(input: ProjectDescInput): Promise<string> {
  const response = await fetch(`${API_BASE}/generate-project-desc`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'AI生成に失敗しました');
  }

  const data = await response.json();
  return data.description;
}

export async function suggestSkills(input: SkillSuggestInput): Promise<SkillSuggestion[]> {
  const response = await fetch(`${API_BASE}/suggest-skills`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'AI生成に失敗しました');
  }

  const data = await response.json();
  return data.suggestions;
}

export async function analyzeSkills(input: SkillAnalyzeInput): Promise<AnalyzedSkill[]> {
  const response = await fetch(`${API_BASE}/analyze-skills`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'AI分析に失敗しました');
  }

  const data = await response.json();
  return data.skills;
}

export async function suggestNextSkills(input: NextSkillsInput): Promise<SkillSuggestion[]> {
  const response = await fetch(`${API_BASE}/suggest-next-skills`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'AI提案に失敗しました');
  }

  const data = await response.json();
  return data.suggestions;
}
